<template>
        <Row :gutter="32">
            <i-col :xs="12">
                <Table :columns="columns" :loading="dataLoading" :data="hardwareModules" class="table-hide-subheader" :row-class-name="FirmwareModuleRowClassName"  @on-row-click="onFirmwareModuleRowClick" :height="300">
                    <div slot-scope="{ row, index }" slot="ModuleName">
                        <span v-if="row.ModuleName">{{ row.ModuleName}}</span>
                        <span v-else>-</span>
                    </div>
                    <div slot-scope="{ row, index }" slot="HardwareVersion">
                        <span v-if="row.HardwareVersion && row.HardwareVersion!==0">V{{ row.HardwareVersion}}</span>
                        <span v-else>\Not Set</span>
                    </div>
                    <div slot-scope="{ row, index }" slot="action">
                        <Button type="error" size="small" @click="deleteHardwareModule(row,index)">Delete</Button>
                    </div>
                </Table>
                <Button long style="margin-top: 8px;"
                        type="primary"
                        :loading="submitLoading"
                        @click="handleCreate"
                >       <span v-if="!submitLoading">Add h/w Module</span>
                    <span v-else>Processing...</span>
                </Button>
            </i-col>
            <i-col :xs="12">
                <div class="add-form">
                    <HardwareForm ref="moduleForm" @getHardwareModules="getHardwareModules" @setActive="setActive" :hardwareModules="hardwareModules" @setActiveHardware="onFirmwareModuleRowClick"></HardwareForm>
                </div>
            </i-col>
        </Row>

</template>

<script>
    import { bus } from "../../main";
    import {getHardwares, addHardware, deleteHardware } from "../../_services/firmware.service";
    import HardwareForm from "./HardwareForm"

    export default {
        data() {
            return {
                languages: [],
                selectedLanguage: null,
                activeModule:null,
                submitLoading:false,
                columns: [
                    {
                        title: "Existing h/w modules",
                        children: [
                            {
                                title: " ",
                                slot: "ModuleName",
                            },
                            {
                                title: " ",
                                slot: "HardwareVersion",
                                maxWidth:150,
                            },
                            {
                                title: " ",
                                slot: "action",
                                width: 100,
                                align: "right"
                            }
                        ]
                    },
                ],
                hardwareModules: [],
                dataLoading:true,
            };
        },
        components:{
            HardwareForm
        },
        methods: {
            getHardwareModules(data){
                getHardwares({Description:true}).then( res=>{
                    this.hardwareModules=res.data.data
                    this.dataLoading=false
                    if(data){
                        this.onFirmwareModuleRowClick(data)
                    }
                }).catch(err=>{
                    bus.$emit('requestError',err)
                    this.dataLoading = false
                    this.$Message.error("Failed to get Firmwares. Please try again later.");
                })
            },
            handleCreate(){
                let hardwareData={
                    ModuleName: "",
                    HardwareVersion:1,
                    HardwareDescription:""
                }
                this.submitLoading=true
                addHardware(hardwareData).then(res => {
                    this.$Message.success(`New hardware successfully added!`);
                    this.getHardwareModules(res.data.data)
                    this.submitLoading = false
                }).catch(err => {
                    bus.$emit('requestError',err)
                    this.submitLoading = false
                    this.$Message.error('Failed to create module. Please try again later.')
                })
            },
            async onFirmwareModuleRowClick(data,index){
                if(this.activeModule===index){
                    this.activeModule=null
                    this.$refs.moduleForm.resetForm()
                    bus.$emit('hardwareChanged',null)
                }else {
                    if(data){
                        let vIndex = this.hardwareModules.map(function(e) { return e._id; }).indexOf(data._id);
                        if(vIndex===-1){
                            this.activeModule = index
                        }else {
                            this.activeModule = await vIndex
                        }
                    }let hardware=Object.assign({},data)
                   await this.$refs.moduleForm.setUpdateData(hardware)
                }
            },

            FirmwareModuleRowClassName(row, index) {
                if (index === this.activeModule) {
                    return 'active-table-row';
                }
                return '';
            },
            async setActive(data){
                if(!data){
                    this.activeModule=null
                }else{
                    let vIndex = this.hardwareModules.map(function(e) { return e._id; }).indexOf(data._id);
                    if(vIndex===-1){
                        this.activeModule = null
                    }else {
                        this.activeModule = await vIndex
                    }
                }
            },
            deleteHardwareModule(data,index) {
                this.$Modal.confirm({
                    title: 'Remove Hardware',
                    content: "Are you sure you want to remove hardware module?",
                    okText: 'Remove',
                    cancelText: 'Cancel',
                    onOk: () => {
                        this.dataLoading = true
                        deleteHardware(data._id).then(res => {
                            bus.$emit('hardwareChanged',null)
                            this.hardwareModules.splice(index, 1);
                            this.dataLoading = false
                            this.$refs.moduleForm.resetForm()
                            this.activeModule=null
                            this.$Message.success(`Successfully deleted module ${data.ModuleName}!`);
                        }).catch(err => {
                            this.dataLoading = false
                            this.$Message.error("Failed to remove module. Please try again later.");
                        });
                    },
                });
            },
        },
        mounted() {
            this.getHardwareModules();
        }
    };
</script>
<style scoped>
.add-form{
    min-height: 300px;
}
</style>
